/**
 * UPT-2096 (P1-a, §4.1) — miniatures d'images : URL d'objet d'un PNG
 * RÉ-ENCODÉ seulement (assertion de type ; seul endroit avec `download.ts` où
 * `URL.createObjectURL` est permis, garde gate:prototype). Révocation par
 * `revokeImageUrl` au démontage du composant.
 */
export const createImageUrl = (png: Blob): string | null => {
  if (png.type !== 'image/png') return null;
  return URL.createObjectURL(png);
};

export const revokeImageUrl = (url: string | null): void => {
  if (url) {
    try {
      URL.revokeObjectURL(url);
    } catch {
      // Révocation au mieux.
    }
  }
};
